// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-details-expanded {
  border-top: 1px solid #f1f1f1;
  margin-top: 16px;
  padding: 1.2rem;
}
.contact-details-expanded .address {
  margin-top: 12px;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/Cards/PublisherContactCondensed/index.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,gBAAA;EACA,eAAA;AACF;AACE;EACE,gBAAA;AACJ","sourcesContent":[".contact-details-expanded {\n  border-top: 1px solid #f1f1f1;\n  margin-top: 16px;\n  padding: 1.2rem;\n\n  .address {\n    margin-top: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
